import Util from '../../Common/Util';
/**
 * 관리자 > 계산서 발행요청 / 발송내역 ($j.Pages.Admin.TaxMessage / body data-page-name="TaxMessage")
 *
 * blade 는 DOM + 서버 값(#page-data — TaxMessageController $pageData) 만 담당하고,
 * 발행요청 탭 / 발송내역 탭 / LMS 발송 모달 / 미리보기 로직 일체는 이 클래스가 처리한다.
 *
 * HTML 인라인 onclick 은 모두 `$j.p.method()` 형태로 호출.
 *
 * 서버 값 (#page-data):
 *   { bonsaList, g5Host, smsTemplates, senderPhones }
 */
export default class TaxMessage {
    initialize() {
        const DATA = JSON.parse(document.getElementById('page-data')?.textContent || '{}');

        // ── 서버 주입 ──
        this.bonsaList    = DATA.bonsaList    || [];
        this.g5Host       = DATA.g5Host       || '';
        this.senderPhones = DATA.senderPhones || [];

        // 템플릿: [{id:'t_xxx', code, nm, bd, fromPhone}]
        this.tpls = (DATA.smsTemplates || []).map(t => ({
            id: 't_' + t.detail_purpose,
            code: t.detail_purpose,
            nm: t.title,
            bd: t.body,
            fromPhone: t.from_phone || '',
        }));

        // ── 화면 상태 ──
        this.selectedRows = {};        // 발행요청 탭: num => DataTables row
        this.$reqTable    = null;      // 발행요청 DataTable 인스턴스
        this.$logTable    = null;      // 발송내역 DataTable 인스턴스
        this.lastFilter   = null;      // 마지막 검색 필터 (엑셀 다운로드용)
        this.logStatus    = '';        // 발송내역 결과 필터 ('' | ok | part | fail | pending)
        this.logInited    = false;     // 발송내역 탭 init 여부

        this.rcsList      = [];        // 발송 모달: 수신자 그룹 배열
        this.rcsSelIdx    = 0;
        this.currentTplBd = '';        // 원본 템플릿 본문

        // 업종 → 배지 클래스
        // 업종 → 칩 번호는 서버 상수 G5_CARTYPE_CHIP 이 정본이다 (app/Common/constants.php).
        // 여기 표를 따로 들고 있었더니 외부회원 관리와 사다리·크레인이 뒤바뀌어 있었다 (2026-09-18 통일).
        this.bgm = Object.fromEntries(
            Object.entries(G5['CARTYPE_CHIP'] || {}).map(([k, n]) => [k, 'bg-' + n])
        );

        // 요일
        this.DAYS = ['일','월','화','수','목','금','토'];

        this.initRequestTab();
        this.bindModalGlobalEvents();
        // 발송내역 탭은 lazy init — 탭 활성화 시 logInit() 호출
    }

    // ============================================================
    //  공통 헬퍼
    // ============================================================

    toast(m) {
        $j.F.Admin.Util.adminToast('success', m); // 관리자 공용 토스트로 통일
    }

    // YYYY-MM-DD → 'YY-MM-DD(요일)'
    fmtD(v) {
        if (!v) return '';
        const d = new Date(v);
        return Util.pad(d.getFullYear() % 100, 2) + '-' + Util.pad(d.getMonth()+1, 2) + '-' + Util.pad(d.getDate(), 2) + '(' + this.DAYS[d.getDay()] + ')';
    }

    // 본사명 → 템플릿 카테고리 (jbbuller / samsung / etc)
    bonsaCategory(name) {
        const n = String(name || '');
        if (n.indexOf('장비불러') !== -1) return 'jbbuller';
        if (n.indexOf('삼성')     !== -1) return 'samsung';
        return 'etc';
    }
    tplByCode(c) { return this.tpls.find(t => t.code === c); }
    pickTpl(bonsaName) {
        const n = String(bonsaName || '');
        if (n.indexOf('장비불러') !== -1) return this.tplByCode('jbbuller') || this.tplByCode('tax');
        if (n.indexOf('삼성')     !== -1) return this.tplByCode('samsung')  || this.tplByCode('tax');
        if (n)                            return this.tplByCode('etc')      || this.tplByCode('tax');
        return this.tplByCode('tax') || this.tpls[0];
    }

    // ============================================================
    //  탭 / 안내 박스
    // ============================================================
    showPage(p, btn) {
        $('.taxmsg-root .page').removeClass('on');
        $('.taxmsg-root .nav-tab').removeClass('on');
        $('#tx-pg-' + p).addClass('on');
        $(btn).addClass('on');
        $('.taxmsg-root .info-box').removeClass('show');
        $('#txInfoBtn').removeClass('on');
        if (p === 'log') this.logInit();
    }
    toggleInfo() {
        const $btn = $('#txInfoBtn').toggleClass('on');
        $('.taxmsg-root .info-box').removeClass('show');
        if ($btn.hasClass('on')) {
            const id = $('#tx-pg-main').hasClass('on') ? 'info-main' : 'info-log';
            $('#' + id).addClass('show');
        }
    }

    // ============================================================
    //  발행요청 탭
    // ============================================================
    initRequestTab() {
        this.renderBonsaDropdown();
        this.bindBonsaDropdownEvents();
        this.bindDatePillEvents('req');
        this.setMonthRange('req', 'tm');
        this.bindRequestEvents();
        this.initRequestTable();
    }

    renderBonsaDropdown() {
        const $drop = $('#mdrop').empty();
        $drop.append('<div class="mo mo-all" data-name="전체"><input type="checkbox" id="bonsa-all-cb"><b>전체</b></div>');
        this.bonsaList.forEach(b => {
            $drop.append('<div class="mo" data-code="'+Util.escapeHtml(b.code)+'" data-name="'+Util.escapeHtml(b.name)+'"><input type="checkbox" data-v="'+Util.escapeHtml(b.code)+'">'+Util.escapeHtml(b.name)+'</div>');
        });
    }

    selectedBonsaCodes() {
        return $('#mdrop .mo:not(.mo-all) input:checked').map(function(){ return $(this).data('v'); }).get();
    }
    selectedBonsaNames() {
        return $('#mdrop .mo:not(.mo-all) input:checked').map(function(){ return $(this).closest('.mo').data('name'); }).get();
    }
    syncAllBonsaCheckbox() {
        const $items = $('#mdrop .mo:not(.mo-all) input');
        const allChecked = $items.length > 0 && $items.filter(':checked').length === $items.length;
        $('#bonsa-all-cb').prop('checked', allChecked);
    }
    isJbbSelected() {
        return $('#mdrop .mo').filter(function(){ return $(this).data('name') === '장비불러'; }).find('input').is(':checked');
    }
    syncOrdererInput() {
        if (this.isJbbSelected()) $('#fg-orderer').css('display','flex');
        else { $('#fg-orderer').hide(); $('#fso').val(''); }
    }
    renderBonsaTags() {
        const names = this.selectedBonsaNames();
        const $tags = $('#mtags').empty();
        if (!names.length) { $tags.html('<span class="ph">전체</span>'); return; }
        const MAX = 3;
        names.slice(0, MAX).forEach(n => $tags.append('<span class="ms-tag">'+Util.escapeHtml(n)+'</span>'));
        if (names.length > MAX) {
            $tags.append('<span class="ms-tag" title="'+Util.escapeHtml(names.slice(MAX).join(', '))+'">+'+(names.length - MAX)+'</span>');
        }
    }

    bindBonsaDropdownEvents() {
        $('#mtrig').on('click', (e) => {
            e.stopPropagation();
            $('#mdrop').toggleClass('open');
            $('#mtrig').toggleClass('open');
        });
        $('#mdrop').on('click', '.mo', (e) => {
            e.stopPropagation();
            const $mo = $(e.currentTarget);
            const $cb = $mo.find('input');
            const willBe = !$cb.prop('checked');
            $cb.prop('checked', willBe);
            if ($mo.hasClass('mo-all')) {
                $('#mdrop .mo:not(.mo-all) input').prop('checked', willBe);
            } else {
                this.syncAllBonsaCheckbox();
            }
            this.renderBonsaTags();
            this.syncOrdererInput();
            this.reload();
        });
        $(document).on('click.taxmsg', (e) => {
            if (!$(e.target).closest('#mw').length) {
                $('#mdrop').removeClass('open');
                $('#mtrig').removeClass('open');
            }
        });
    }

    setMonthRange(scope, type) {
        const fId = scope === 'req' ? '#df' : '#ldf';
        const tId = scope === 'req' ? '#dt' : '#ldt';
        const n = new Date();
        let y, m, l;
        if (type === 'tm') {
            y = n.getFullYear(); m = n.getMonth();
            l = new Date(y, m+1, 0);
            $(fId).val(y+'-'+Util.pad(m+1, 2)+'-01');
            // 발송내역 이달: 오늘까지. 발행요청 이달: 말일까지.
            const dayTo = scope === 'log' ? n.getDate() : l.getDate();
            $(tId).val(y+'-'+Util.pad(m+1, 2)+'-'+Util.pad(dayTo, 2));
        } else if (type === 'lm') {
            const p = new Date(n.getFullYear(), n.getMonth()-1, 1);
            l = new Date(n.getFullYear(), n.getMonth(), 0);
            $(fId).val(p.getFullYear()+'-'+Util.pad(p.getMonth()+1, 2)+'-01');
            $(tId).val(l.getFullYear()+'-'+Util.pad(l.getMonth()+1, 2)+'-'+Util.pad(l.getDate(), 2));
        }
    }

    bindDatePillEvents(scope) {
        const attr = scope === 'req' ? 'data-p' : 'data-lp';
        const fId  = scope === 'req' ? '#df' : '#ldf';
        const tId  = scope === 'req' ? '#dt' : '#ldt';
        $('.taxmsg-root .pill['+attr+']').on('click', (e) => {
            const $btn = $(e.currentTarget);
            const p = $btn.data(scope === 'req' ? 'p' : 'lp');
            $('.taxmsg-root .pill['+attr+']').removeClass('active');
            $btn.addClass('active');
            if (p !== 'c') {
                this.setMonthRange(scope, p);
                if (scope === 'req') this.reload();
                else if (this.$logTable) this.$logTable.ajax.reload();
            } else if (scope === 'log' && this.$logTable) {
                this.$logTable.ajax.reload();
            }
        });
        $(fId + ', ' + tId).on('change', () => {
            $('.taxmsg-root .pill['+attr+']').removeClass('active');
            $('.taxmsg-root .pill['+attr+'="c"]').addClass('active');
            if (scope === 'req') this.reload();
            else if (this.$logTable) this.$logTable.ajax.reload();
        });
    }

    initRequestTable() {
        if (this.$reqTable) { this.$reqTable.destroy(); $('#tx-req-table tbody').empty(); }
        const self = this;
        this.$reqTable = new DataTable('#tx-req-table', {
            ajax: {
                url: '/adm/ajax/account/tax-message/list',
                type: 'post',
                data: (d) => {
                    d.start_date = $('#df').val();
                    d.end_date = $('#dt').val();
                    d.bonsa_codes = this.selectedBonsaCodes();
                    d.keyword = $('#fs').val();
                    d.order_keyword = this.isJbbSelected() ? ($('#fso').val() || '') : '';
                    this.lastFilter = {
                        start_date: d.start_date,
                        end_date: d.end_date,
                        keyword: d.keyword,
                        order_keyword: d.order_keyword,
                        bonsa_codes: d.bonsa_codes,
                    };
                },
                dataSrc: (json) => {
                    $('#tc').text(json.recordsTotal || 0);
                    return json.data || [];
                },
            },
            columns: [
                {data: null, orderable: false, className: 'ct', render: (_, __, row) => '<input type="checkbox" class="row-cb" data-num="'+row.num+'">'},
                {data: null, className: 'ct', render: (_, __, row) => '<a href="javascript:$j.p.openOrderDetail('+row.num+')" class="on2" style="color:var(--adm-c-1d4ed8, #1D4ED8);text-decoration:none">'+row.num+'</a>'},
                {data: 'sent', className: 'ct', render: (v) => parseInt(v) ? '<span class="sent-tag">완료</span>' : ''},
                {data: 'car_type', className: 'ct', render: (v) => '<span class="bg '+(this.bgm[v]||'')+'">'+Util.escapeHtml(v||'')+'</span>'},
                {data: null, orderable: false, className: 'ct', render: (_, __, row) => {
                    if (!parseInt(row.order_mb_no)) return Util.escapeHtml(row.order_name || '—');
                    return $j.F.Admin.Member.Pop.cell(row.order_mb_no, row.order_name);
                }},
                {data: 'bonsa_name', className: 'ct', render: (v) => Util.escapeHtml(v)},
                {data: 'gisa_name', className: 'ct', render: (v) => Util.escapeHtml(v)},
                {data: 'address', className: 'ad', orderable: false, render: (v) => Util.escapeHtml(v)},
                {data: 'work_time', className: 'ct', render: (v, __, row) => {
                    let txt = '—';
                    if (v) {
                        txt = v.length >= 16
                            ? v.substring(5, 10).replace(/-/g, '.') + ' ' + v.substring(11, 16)
                            : v;
                    }
                    if (parseInt(row.order_status) != 8) txt += ' <span class="wk-tag">⚠ 미완료</span>';
                    return txt;
                }},
                {data: 'workhour', className: 'ct', orderable: false, render: (v) => Util.escapeHtml(v)},
                {data: 'car_price', className: 'am', render: (v) => (parseInt(v)||0).toLocaleString() + '원'},
                {data: null, className: 'ct', render: (_, __, row) => {
                    if (!parseInt(row.worker_mb_no)) return Util.escapeHtml(row.worker_name || '—');
                    return $j.F.Admin.Member.Pop.cell(row.worker_mb_no, row.worker_name);
                }},
                {data: 'worker_phone', className: 'ct2', orderable: false, render: (v) => Util.escapeHtml(v || '—')},
            ],
            rowCallback: function(row, data) {
                const $row = $(row).attr('data-num', data.num);
                if (parseInt(data.sent)) $row.addClass('sent');
                if (self.selectedRows[data.num]) {
                    $row.addClass('sel').find('.row-cb').prop('checked', true);
                }
            },
            drawCallback: () => this.syncBsaState(),
            processing: true,
            serverSide: true,
            ordering: true,
            order: [[8, 'desc']],
            displayLength: parseInt($('#psSel').val()) || 20,
            lengthChange: false,
            searching: false,
            language: {
                emptyTable: '데이터가 없습니다',
                zeroRecords: '데이터가 없습니다',
                processing: '불러오는 중…',
            },
        });
    }

    openOrderDetail(num) {
        $j.F.Admin.Util.openOrderHandle(num);
    }

    bindRequestEvents() {
        // 체크박스 — 한 행
        $('#tx-req-table tbody').on('change', '.row-cb', (e) => {
            const $cb = $(e.currentTarget);
            const num = $cb.data('num');
            const $tr = $cb.closest('tr');
            const rowData = this.$reqTable.row($tr).data();
            if (e.currentTarget.checked) {
                this.selectedRows[num] = rowData;
                $tr.addClass('sel');
            } else {
                delete this.selectedRows[num];
                $tr.removeClass('sel');
            }
            this.updateSummary();
            this.syncPageCheckAll();
            this.syncBsaState();
        });

        // 페이지 전체 선택
        $('#ca').on('change', (e) => {
            const checked = e.currentTarget.checked;
            $('#tx-req-table tbody .row-cb').each(function(){
                if (this.checked !== checked) $(this).prop('checked', checked).trigger('change');
            });
        });

        // 발송완료 제외 선택 / 선택취소
        $('#bsa').on('click', () => {
            const unsent = this.pageUnsentRows();
            if (!unsent.length) { this.toast('이 페이지에는 미발송 오더가 없습니다'); return; }
            const allSelected = unsent.every(d => this.selectedRows[d.num]);
            const targetRows = allSelected ? this.$reqTable.rows().data().toArray() : unsent;
            targetRows.forEach(d => {
                const $tr = $('#tx-req-table tbody tr[data-num="'+d.num+'"]');
                const $cb = $tr.find('.row-cb');
                if (allSelected) {
                    delete this.selectedRows[d.num];
                    $cb.prop('checked', false);
                    $tr.removeClass('sel');
                } else {
                    this.selectedRows[d.num] = d;
                    $cb.prop('checked', true);
                    $tr.addClass('sel');
                }
            });
            this.updateSummary();
            this.syncPageCheckAll();
            this.syncBsaState();
        });

        // 페이지 사이즈
        $('#psSel').on('change', (e) => {
            if (!this.$reqTable) return;
            this.$reqTable.page.len(parseInt(e.currentTarget.value) || 20).draw();
        });

        // 검색 / 초기화
        $('#tx-req-search').on('click', () => this.reload());
        $('#tx-req-reset').on('click', () => {
            $('#mdrop input').prop('checked', false);
            this.renderBonsaTags();
            this.syncOrdererInput();
            $('#fs').val('');
            $('.taxmsg-root .pill[data-p]').removeClass('active');
            $('.taxmsg-root .pill[data-p="tm"]').addClass('active');
            this.setMonthRange('req', 'tm');
            this.reload();
        });
        $('#tx-req-fab-clear').on('click', () => {
            $('#mdrop input').prop('checked', false);
            this.renderBonsaTags();
            this.syncOrdererInput();
            $('#fs').val('');
            this.reload();
        });
        $('#fabt').on('click', '.fab-x', (e) => {
            const $x = $(e.currentTarget);
            if ($x.data('keyword'))      { $('#fs').val(''); }
            else if ($x.data('orderer')) { $('#fso').val(''); }
            else {
                const name = $x.data('name');
                $('#mdrop .mo').filter(function(){ return $(this).data('name') === name; }).find('input').prop('checked', false);
                this.syncAllBonsaCheckbox();
                this.renderBonsaTags();
                this.syncOrdererInput();
            }
            this.reload();
        });
        $('#fs, #fso').on('keydown', (e) => { if (e.key === 'Enter') this.reload(); });

        // 엑셀 다운로드
        $('#tx-req-excel').on('click', () => {
            if (!this.lastFilter) { this.toast('먼저 검색해 주세요'); return; }
            const qs = $.param(this.lastFilter);
            window.location.href = '/adm/account/tax-message/excel?' + qs;
        });
    }

    pageUnsentRows() {
        if (!this.$reqTable) return [];
        return this.$reqTable.rows().data().toArray().filter(d => !parseInt(d.sent));
    }

    syncBsaState() {
        const unsent = this.pageUnsentRows();
        const $bsa = $('#bsa').prop('disabled', false);
        if (!unsent.length) {
            $bsa.removeClass('on').text('발송완료 제외 선택');
            return;
        }
        const allSelected = unsent.every(d => this.selectedRows[d.num]);
        if (allSelected) $bsa.addClass('on').text('선택취소');
        else $bsa.removeClass('on').text('발송완료 제외 선택');
    }

    syncPageCheckAll() {
        const $cbs = $('#tx-req-table tbody .row-cb');
        if (!$cbs.length) { $('#ca').prop('checked', false); return; }
        const allChecked = $cbs.length > 0 && $cbs.filter(':checked').length === $cbs.length;
        $('#ca').prop('checked', allChecked);
    }

    updateSummary() {
        const rows = Object.values(this.selectedRows);
        const cnt = rows.length;
        let sum = 0;
        rows.forEach(r => sum += parseInt(r.car_price) || 0);
        $('#selc').text(cnt);
        $('#selam').text(sum.toLocaleString());
        $('#brcs').prop('disabled', cnt === 0);
    }

    updateFab() {
        const s  = ($('#fs').val()  || '').trim();
        const so = this.isJbbSelected() ? ($('#fso').val() || '').trim() : '';
        const names = this.selectedBonsaNames();
        const tags = [];
        names.forEach(n => tags.push('<span class="fab-t">'+n+'<button class="fab-x" data-name="'+n+'">✕</button></span>'));
        if (s)  tags.push('<span class="fab-t">"'+s+'"<button class="fab-x" data-keyword="1">✕</button></span>');
        if (so) tags.push('<span class="fab-t">발주자:"'+so+'"<button class="fab-x" data-orderer="1">✕</button></span>');
        if (tags.length) { $('#fabt').html(tags.join('')); $('#fabr').addClass('show'); }
        else $('#fabr').removeClass('show');
    }

    reload() {
        this.selectedRows = {};
        this.updateSummary();
        $('#ca').prop('checked', false);
        this.$reqTable.ajax.reload(null, false);
        this.updateFab();
    }

    // 발송 완료 후 외부에서 호출
    reloadAfterSend() {
        this.selectedRows = {};
        $('#ca').prop('checked', false);
        this.updateSummary();
        this.$reqTable.ajax.reload(null, false);
    }

    // ============================================================
    //  발송내역 탭 (lazy init)
    // ============================================================
    logInit() {
        if (!this.logInited) {
            this.setMonthRange('log', 'tm');
            this.bindDatePillEvents('log');
            this.bindLogEvents();
            this.initLogTable();
            this.logInited = true;
            return;
        }
        if (this.$logTable) this.$logTable.ajax.reload(null, false);
    }

    initLogTable() {
        if (this.$logTable) { this.$logTable.destroy(); $('#tx-log-table tbody').empty(); }
        this.$logTable = new DataTable('#tx-log-table', {
            ajax: {
                url: '/adm/ajax/account/tax-message/log/list',
                type: 'post',
                data: (d) => {
                    d.start_date = $('#ldf').val();
                    d.end_date   = $('#ldt').val();
                    d.keyword    = $('#logS').val();
                    d.result     = this.logStatus;
                },
            },
            autoWidth: false,
            columns: [
                {data: 'created_at',  className: 'ct'},
                {data: 'manage_name', className: 'ct', render: (v) => Util.escapeHtml(v)},
                {data: 'detail_purpose', className: 'ct', render: (v) => {
                    if (!v) return '—';
                    const t = this.tplByCode(v);
                    return '<span class="badge ' + (v === 'samsung' ? 'badge-info' : 'badge-warning') + '">' + (t ? t.nm : v) + '</span>';
                }},
                {data: 'recipient_count', className: 'ct', render: (v) => (v||0) + '명'},
                {data: 'order_count',     className: 'ct', render: (v) => (v||0) + '건'},
                {data: 'total_amount', className: 'am', render: (v) => '<span style="font-weight:700;font-variant-numeric:tabular-nums">'+(parseInt(v)||0).toLocaleString()+'원</span>'},
                {data: null, className: 'ct', render: (_, __, row) => {
                    const st = row.result_status;
                    const cls = st === 'ok' ? 'badge-success' : (st === 'fail' ? 'badge-danger' : 'badge-warning');
                    return '<span class="badge '+cls+'">'+row.result_label+'</span>';
                }},
            ],
            rowCallback: (row, data) => $(row).attr('data-gid', data.group_id),
            processing: true,
            serverSide: true,
            ordering: true,
            order: [[0, 'desc']],
            displayLength: 20,
            lengthChange: false,
            searching: false,
            language: {
                emptyTable: '발송내역이 없습니다',
                zeroRecords: '발송내역이 없습니다',
                processing: '불러오는 중…',
            },
        });
    }

    bindLogEvents() {
        // 검색 / 초기화
        $('#tx-log-search').on('click', () => this.$logTable && this.$logTable.ajax.reload());

        // 발송결과 태그 버튼 — 단일 선택 → 즉시 재검색
        $('#tx-log-status').on('click', '.st-pill', (e) => {
            const $b = $(e.currentTarget);
            $('#tx-log-status .st-pill').removeClass('active');
            $b.addClass('active');
            this.logStatus = $b.data('st') || '';
            this.$logTable && this.$logTable.ajax.reload();
        });

        $('#tx-log-reset').on('click', () => {
            $('#logS').val('');
            this.logStatus = '';
            $('#tx-log-status .st-pill').removeClass('active');
            $('#tx-log-status .st-pill[data-st=""]').addClass('active');
            $('.taxmsg-root .pill[data-lp]').removeClass('active');
            $('.taxmsg-root .pill[data-lp="tm"]').addClass('active');
            this.setMonthRange('log', 'tm');
            this.$logTable && this.$logTable.ajax.reload();
        });
        $('#logS').on('keydown', (e) => { if (e.key === 'Enter') $('#tx-log-search').click(); });

        // 행 클릭 — 수신자 목록 토글 (다시 누르면 접힘)
        $('#tx-log-table tbody').on('click', 'tr', (e) => {
            const $tr = $(e.currentTarget);
            if ($tr.hasClass('child')) return;              // 펼쳐진 수신자 영역은 제외
            const row = this.$logTable.row($tr);
            const data = row.data();
            if (!data) return;                              // '내역 없음' 안내행

            if (row.child.isShown()) {
                row.child.hide();
                $tr.removeClass('shown');
                return;
            }

            $.post('/adm/ajax/account/tax-message/log/recipients', { group_id: data.group_id }, (res) => {
                if (!res || !res.ok) { this.toast('수신자 조회 실패'); return; }
                row.child(this.renderRecipients(res.data || []), 'child').show();
                $tr.addClass('shown');
            });
        });

        // 수신자 카드 클릭 → 오더 상세를 새 창으로 표시 (인라인 펼침 대신)
        $('#tx-log-table tbody').on('click', '.ld-person', (e) => {
            const $person = $(e.currentTarget);
            const $st     = $person.find('.ld-st');
            const meta = {
                rnum:    $person.data('rnum'),
                name:    $person.find('.ld-nm').text().trim(),
                phone:   $person.find('.ld-ph').text().trim(),
                cnt:     $person.find('.ld-cnt').text().trim(),
                amount:  $person.find('.ld-am').text().trim(),
                stLabel: $st.text().trim(),
                stCls:   $st.hasClass('ok') ? 'ok' : ($st.hasClass('fail') ? 'fail' : ''),
            };

            // 팝업차단 회피 위해 클릭 즉시 창을 열고 로딩 표시 → AJAX 후 내용 교체
            const w = window.open('', 'taxOrderDetail_' + meta.rnum, 'width=1180,height=860,scrollbars=yes,resizable=yes');
            if (!w) { this.toast('팝업이 차단되었습니다. 팝업 허용 후 다시 시도해주세요.'); return; }
            const writeWin = (body, message, loading) => {
                if (w.closed) return;
                w.document.open();
                w.document.write(this.orderWindowHtml(meta, body, message || '', !!loading));
                w.document.close();
            };
            writeWin('<div style="padding:34px;text-align:center;color:var(--adm-c-909090, #909090)">불러오는 중...</div>', '', true);
            w.focus();

            $.post('/adm/ajax/account/tax-message/log/detail', { sms_send_num: meta.rnum }, (res) => {
                writeWin((res && res.ok)
                    ? this.renderOrders(res.data || [])
                    : '<div style="padding:34px;text-align:center;color:var(--adm-c-ff382d, #FF382D)">오더 조회에 실패했습니다.</div>',
                    (res && res.message) || '');
            }).fail(() => writeWin('<div style="padding:34px;text-align:center;color:var(--adm-c-ff382d, #FF382D)">서버 오류가 발생했습니다.</div>', ''));
        });

        // 오더상세 새창에서 '전체 건수 재발송' 위임 — 확인(SweetAlert)은 새창 안에서 띄우므로
        // 여기선 바로 실행한다.
        window.taxResendFromPopup = (rnum) => this.doResend(rnum);
    }

    /** 재발송 실행 (확인 절차는 호출부에서). $btn 이 있으면 처리중 표시. */
    doResend(rnum, $btn) {
        if ($btn) $btn.prop('disabled', true).text('처리중...');
        $.post('/adm/ajax/account/tax-message/resend', { sms_send_num: rnum }, (res) => {
            if (res && res.ok) {
                this.toast('재발송 요청 완료');
                this.$logTable.ajax.reload(null, false);
            } else {
                this.toast((res && res.message) || '재발송 실패');
            }
        }).fail(() => this.toast('서버 오류가 발생했습니다'))
          .always(() => { if ($btn) $btn.prop('disabled', false).text('재발송'); });
    }

    renderRecipients(recipients) {
        if (!recipients || !recipients.length) return '<div style="padding:14px;color:var(--adm-c-909090, #909090)">수신자가 없습니다.</div>';
        let html = '<div style="padding:8px 10px 8px 24px;background:var(--adm-b-f7f7f8, #F7F7F8)">';
        recipients.forEach((r, idx) => {
            const stCls = r.status === '1' ? 'ok' : (r.status === '2' ? 'fail' : '');
            const typeLbl = r.order_count > 1 ? '여러건' : '단건';
            html += '<div class="ld-block" data-rnum="'+r.num+'">'
                  + '<div class="ld-person" data-rnum="'+r.num+'">'
                  +   '<span style="font-size:16px;font-weight:700;color:var(--adm-c-909090, #909090);width:24px;text-align:center;flex-shrink:0">'+(idx+1)+'</span>'
                  // 회원이면 `이름#번호` + 회원 팝오버 — 줄을 누르면 상세가 펼쳐지므로 stop
                  +   '<span class="ld-nm">'+(parseInt(r.mb_no) ? $j.F.Admin.Member.Pop.cell(r.mb_no, r.recipient_name, { stop: true }) : Util.escapeHtml(r.recipient_name||'비회원'))+'</span>'
                  +   '<span class="ld-ph">'+Util.escapeHtml(r.to_phone||'—')+'</span>'
                  +   '<span class="ld-cnt">'+r.order_count+'건</span>'
                  +   '<span class="ld-am">'+(parseInt(r.total_amount)||0).toLocaleString()+'원</span>'
                  +   '<span class="ld-st '+stCls+'">'+r.status_label+'</span>'
                  +   '<span class="ld-type">'+typeLbl+'</span>'
                  + '</div>'
                  + '<div class="ld-sub" data-rnum="'+r.num+'"></div>'
                  + '</div>';
        });
        html += '</div>';
        return html;
    }

    renderOrders(orders) {
        if (!orders || !orders.length) return '<div class="empty">관련 오더가 없습니다.</div>';
        const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        const rows = orders.map((o, i) => {
            const price = o.car_price ? Number(o.car_price).toLocaleString() : '0';
            const wday  = o.work_day || '—';
            const wtime = o.work_time ? `<small>${esc(o.work_time)}</small>` : '';
            return '<tr>'
                 +   '<td class="c-no">' + (i + 1) + '</td>'
                 +   '<td class="c-onum">' + esc(o.ordernum) + '</td>'
                 +   '<td class="c-biz">' + esc(o.car_type || '—') + '</td>'
                 +   '<td class="c-addr">' + esc(o.site_address || '—') + '</td>'
                 +   '<td class="c-day">' + esc(wday) + wtime + '</td>'
                 +   '<td class="c-amt">' + price + '원</td>'
                 + '</tr>';
        }).join('');
        const total = orders.reduce((s, o) => s + (Number(o.car_price) || 0), 0).toLocaleString();
        return '<table class="ord-tbl">'
             + '<thead><tr>'
             +   '<th class="c-no">#</th><th>오더번호</th><th>업종</th><th>현장주소</th><th>작업일</th><th class="c-amt">금액</th>'
             + '</tr></thead>'
             + '<tbody>' + rows + '</tbody>'
             + '<tfoot><tr><td colspan="5">합계 ' + orders.length + '건</td><td class="c-amt">' + total + '원</td></tr></tfoot>'
             + '</table>';
    }

    /**
     * 오더상세 새 창 문서 — renderOrders() 결과(bodyHtml)를 자체 스타일과 함께 감싼다.
     * (새 창은 부모 페이지 CSS/변수가 없으므로 필요한 스타일을 인라인으로 포함)
     */
    orderWindowHtml(meta, bodyHtml, message, loading) {
        const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        const stLabel = meta.stLabel || '—';
        const stCls   = meta.stCls ? (' ' + meta.stCls) : '';
        const rnum = parseInt(meta.rnum) || 0;
        return '<!DOCTYPE html><html lang="ko"><head><meta charset="UTF-8">'
            + '<meta name="viewport" content="width=device-width, initial-scale=1.0">'
            + '<title>세금계산서 발송 오더상세 — ' + esc(meta.name) + '</title>'
            + '<style>'
            + '*{margin:0;padding:0;box-sizing:border-box}'
            + "body{font-family:'Pretendard',-apple-system,BlinkMacSystemFont,sans-serif;background:var(--adm-b-f2f4f6, #F2F4F6);color:var(--adm-c-191f28, #191F28);letter-spacing:-.3px;padding:20px}"
            + '.hd{background:var(--adm-b-ffffff, #fff);border:1px solid #E5E8EB;border-radius:12px;padding:16px 18px;margin-bottom:14px;display:flex;align-items:center;gap:14px;flex-wrap:wrap}'
            + '.hd .nm{font-size:20px;font-weight:800}'
            + '.hd .ph{font-size:15px;color:var(--adm-c-626262, #626262);font-variant-numeric:tabular-nums}'
            + '.hd .st{font-size:14px;font-weight:700;padding:5px 12px;border-radius:6px;background:var(--adm-b-f1f1f1, #F1F1F1);color:var(--adm-c-626262, #626262)}'
            + '.hd .st.ok{background:var(--adm-b-e7f7ee, #E7F7EE);color:var(--adm-c-0f8a4d, #0F8A4D)}'
            + '.hd .st.fail{background:var(--adm-b-ffefed, #FFEFED);color:var(--adm-c-ff382d, #FF382D)}'
            + '.hd .resend{height:32px;padding:0 14px;border-radius:6px;border:1px solid #1D4ED8;background:var(--adm-b-eff6ff, #EFF6FF);color:var(--adm-c-1d4ed8, #1D4ED8);font-size:14px;font-weight:700;font-family:inherit;cursor:pointer}'
            + '.hd .resend:hover{background:#1D4ED8;color:#fff}'
            + '.hd .resend:disabled{opacity:.5;cursor:default;background:var(--adm-b-f1f1f1, #F1F1F1);color:var(--adm-c-909090, #909090);border-color:#DDD}'
            + '.hd .cnt{margin-left:auto;font-size:14px;color:var(--adm-c-1d4ed8, #1D4ED8);font-weight:700}'
            + '.hd .am{font-size:18px;font-weight:800;font-variant-numeric:tabular-nums}'
            + '.panel{background:var(--adm-b-ffffff, #fff);border:1px solid #E5E8EB;border-radius:12px;overflow:hidden}'
            + '.empty{padding:34px;text-align:center;color:var(--adm-c-909090, #909090)}'
            // 2단 — 좌: 오더목록 / 우: 발송된 문자내용
            + '.cols{display:flex;align-items:flex-start;gap:14px}'
            + '.col-ord{flex:1 1 auto;min-width:0}'
            + '.col-msg{flex:0 0 380px;width:380px}'
            + '@media (max-width:900px){.cols{flex-direction:column}.col-msg{flex:1 1 auto;width:100%}}'
            + '.msg-panel{background:var(--adm-b-ffffff, #fff);border:1px solid #E5E8EB;border-radius:12px;overflow:hidden}'
            + '.msg-hd{display:flex;align-items:center;justify-content:space-between;gap:8px;padding:10px 12px;background:var(--adm-b-f7f8fa, #F7F8FA);border-bottom:1px solid #E5E8EB;font-size:13px;font-weight:700;color:var(--adm-c-626262, #626262)}'
            + '.msg-hd .len{font-weight:600;color:var(--adm-c-909090, #909090);font-variant-numeric:tabular-nums}'
            + '.msg-body{padding:12px}'
            + '.msg-phone{background:#121212;border-radius:14px;padding:16px 12px 14px;position:relative}'
            + '.msg-phone::before{content:"";position:absolute;top:6px;left:50%;transform:translateX(-50%);width:50px;height:4px;background:#3a3a3e;border-radius:3px}'
            + '.msg-bubble{background:var(--adm-b-ffffff, #fff);border-radius:14px 14px 14px 4px;padding:14px;font-size:13px;line-height:1.65;color:var(--adm-c-121212, #121212);white-space:pre-wrap;word-break:break-all;max-height:560px;overflow-y:auto}'
            + '.msg-bubble.dim{color:var(--adm-c-909090, #909090)}'
            + 'table.ord-tbl{width:100%;border-collapse:collapse;font-size:14px}'
            + '.ord-tbl th{background:var(--adm-b-f7f8fa, #F7F8FA);color:var(--adm-c-626262, #626262);font-weight:700;text-align:left;padding:10px 12px;font-size:13px;border-bottom:1px solid #E5E8EB;white-space:nowrap}'
            + '.ord-tbl td{padding:10px 12px;border-bottom:1px solid rgba(0,0,0,.06);color:var(--adm-c-333d4b, #333D4B);vertical-align:middle}'
            + '.ord-tbl tbody tr:last-child td{border-bottom:none}'
            + '.ord-tbl .c-no{width:34px;text-align:center;color:var(--adm-c-909090, #909090)}'
            + '.ord-tbl .c-onum{color:var(--adm-c-1d4ed8, #1D4ED8);font-weight:600;white-space:nowrap;font-variant-numeric:tabular-nums}'
            + '.ord-tbl .c-biz{white-space:nowrap}'
            + '.ord-tbl .c-addr{min-width:200px}'
            + '.ord-tbl .c-day{white-space:nowrap;color:var(--adm-c-626262, #626262);font-variant-numeric:tabular-nums}'
            + '.ord-tbl .c-day small{display:block;color:var(--adm-c-909090, #909090);font-size:12px}'
            + '.ord-tbl .c-amt{text-align:right;white-space:nowrap;font-weight:700;font-variant-numeric:tabular-nums}'
            + '.ord-tbl tfoot td{background:var(--adm-b-f7f8fa, #F7F8FA);font-weight:700;border-top:1px solid #E5E8EB;border-bottom:none}'
            // 재발송 문자 미리보기 오버레이 (whan 발송내역과 동일한 문자 모양)
            + '.rs-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:9999;align-items:center;justify-content:center;padding:20px}'
            + '.rs-overlay.show{display:flex}'
            + '.rs-modal{background:var(--adm-b-ffffff, #fff);border-radius:16px;width:420px;max-width:100%;max-height:calc(90vh / var(--adm-zoom, 1));display:flex;flex-direction:column;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,.4)}'
            + '.rs-head{display:flex;align-items:center;justify-content:space-between;padding:14px 16px;border-bottom:1px solid #F1F1F1;font-size:15px;font-weight:700}'
            + '.rs-head button{border:none;background:var(--adm-b-f1f1f1, #F1F1F1);width:30px;height:30px;border-radius:8px;cursor:pointer;font-size:16px;color:var(--adm-c-626262, #626262)}'
            + '.rs-body{padding:16px;overflow-y:auto}'
            + '.rs-info{font-size:13px;color:var(--adm-c-626262, #626262);font-weight:600;margin-bottom:10px}'
            + '.rs-phone{background:#121212;border-radius:14px;padding:14px 12px 16px;position:relative}'
            + '.rs-phone::before{content:"";position:absolute;top:6px;left:50%;transform:translateX(-50%);width:50px;height:4px;background:#3a3a3e;border-radius:3px}'
            + '.rs-bubble{background:var(--adm-b-ffffff, #fff);border-radius:14px 14px 14px 4px;padding:14px;margin-top:8px;font-size:13px;line-height:1.65;color:var(--adm-c-121212, #121212);white-space:pre-wrap;word-break:break-all;max-height:360px;overflow-y:auto}'
            + '.rs-foot{display:flex;justify-content:flex-end;gap:8px;padding:12px 16px;border-top:1px solid #F1F1F1}'
            + '.rs-foot button{height:40px;padding:0 18px;border-radius:10px;font-size:14px;font-weight:700;cursor:pointer;font-family:inherit}'
            + '.rs-cancel{background:var(--adm-b-ffffff, #fff);border:1px solid #CCC;color:var(--adm-c-626262, #626262)}'
            + '.rs-send{background:#1D4ED8;border:none;color:#fff}'
            + '.rs-send:disabled{opacity:.5;cursor:default}'
            + '</style></head><body>'
            + '<div class="hd">'
            +   '<span class="nm">' + esc(meta.name || '비회원') + '</span>'
            +   '<span class="ph">' + esc(meta.phone) + '</span>'
            +   '<span class="st' + stCls + '">' + esc(stLabel) + '</span>'
            +   '<button type="button" class="resend" onclick="wResend(this,' + rnum + ')">재발송</button>'
            +   '<span class="cnt">' + esc(meta.cnt) + '</span>'
            +   '<span class="am">' + esc(meta.amount) + '</span>'
            + '</div>'
            + '<div class="cols">'
            +   '<div class="col-ord"><div class="panel">' + bodyHtml + '</div></div>'
            +   '<div class="col-msg">' + this.msgPanelHtml(message, loading) + '</div>'
            + '</div>'
            + '<div class="rs-overlay" id="resendOverlay">'
            +   '<div class="rs-modal">'
            +     '<div class="rs-head"><span>🔄 재발송 미리보기</span><button type="button" onclick="rsClose()">✕</button></div>'
            +     '<div class="rs-body">'
            +       '<div class="rs-info">아래 내용 그대로 ' + esc(meta.name || '비회원') + '님에게 다시 발송됩니다.</div>'
            +       '<div class="rs-phone"><div class="rs-bubble" id="rsBubble"></div></div>'
            +     '</div>'
            +     '<div class="rs-foot">'
            +       '<button type="button" class="rs-cancel" onclick="rsClose()">취소</button>'
            +       '<button type="button" class="rs-send" id="rsSendBtn" onclick="rsConfirm()">🔄 재발송</button>'
            +     '</div>'
            +   '</div>'
            + '</div>'
            + '<script>' + this.popupResendScript(message, rnum) + '</scr' + 'ipt>'
            + '</body></html>';
    }

    /** 오더상세 새 창 우측 — 실제 발송된 문자내용 패널 (문자 모양 그대로). */
    msgPanelHtml(message, loading) {
        const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        const msg = String(message == null ? '' : message);
        let bubble;
        if (loading)      bubble = '<div class="msg-bubble dim">불러오는 중...</div>';
        else if (!msg)    bubble = '<div class="msg-bubble dim">저장된 문자내용이 없습니다.</div>';
        else              bubble = '<div class="msg-bubble">' + esc(msg) + '</div>';

        const len = loading ? '' : '<span class="len">' + msg.length + '자</span>';
        return '<div class="msg-panel">'
             +   '<div class="msg-hd"><span>발송된 문자내용</span>' + len + '</div>'
             +   '<div class="msg-body"><div class="msg-phone">' + bubble + '</div></div>'
             + '</div>';
    }

    /** 새창 안 재발송 — 문자 모양 미리보기 오버레이를 띄우고, 확인 시 부모(opener)에 위임.
     *  (whan 발송내역의 문자 미리보기와 동일 흐름) */
    popupResendScript(message, rnum) {
        const msgJson = JSON.stringify(String(message == null ? '' : message)).replace(/<\//g, '<\\/');
        return [
            'var RS_MSG=' + msgJson + ';',
            'var RS_RNUM=' + (parseInt(rnum, 10) || 0) + ';',
            // 재발송 클릭 → 문자 모양 미리보기 오버레이 표시
            'function wResend(btn, rnum){',
            '  if(rnum) RS_RNUM=rnum;',
            '  var b=document.getElementById("rsBubble"); if(b) b.textContent=RS_MSG||"(저장된 메시지가 없습니다)";',
            '  var ov=document.getElementById("resendOverlay"); if(ov) ov.classList.add("show");',
            '}',
            'function rsClose(){ var ov=document.getElementById("resendOverlay"); if(ov) ov.classList.remove("show"); }',
            // 미리보기에서 재발송 확정 → 부모 창에 위임
            'function rsConfirm(){',
            '  if(window.opener && !window.opener.closed && window.opener.taxResendFromPopup){',
            '    window.opener.taxResendFromPopup(RS_RNUM);',
            '    var b=document.getElementById("rsSendBtn"); if(b){ b.disabled=true; b.textContent="요청됨"; }',
            '    rsClose();',
            // 이 줄은 '부모 창(목록)에서' 실행된다 — 부모에는 $j 가 있으므로 공용 토스트를 쓴다
            '    if(window.$j && $j.Ui) $j.Ui.Toast.show("재발송 요청됨", {type:"success"});',
            '  } else { alert("부모 목록 창을 찾을 수 없습니다. 발송내역 목록에서 재발송해주세요."); }',
            '}',
        ].join('\n');
    }

    // ============================================================
    //  LMS 발송 모달
    // ============================================================
    // 본문에 {작성종료일} 이 있으면 from~to 두 개 picker 표시, 없으면 단일 picker
    setupPickersByTpl(body) {
        const hasRange = (body || '').indexOf('{작성종료일}') !== -1;
        const n = new Date(), y = n.getFullYear(), m = n.getMonth();
        const lastDay = new Date(y, m, 0);
        if (hasRange) {
            $('#sdFrom').val(y + '-' + Util.pad(m, 2) + '-28');
            // #sdTo 는 .form-control(block) 이라 hidden 속성으로 — .show() 는 태그 기본값(inline-block)으로 띄운다
            $('#sdTo').val(y + '-' + Util.pad(m, 2) + '-' + Util.pad(lastDay.getDate(), 2)).prop('hidden', false);
            $('#sdRangeSep').show();
        } else {
            $('#sdFrom').val(y + '-' + Util.pad(m, 2) + '-' + Util.pad(lastDay.getDate(), 2));
            $('#sdTo').prop('hidden', true);
            $('#sdRangeSep').hide();
        }
        $('#sdPay').val(y + '-' + Util.pad(m + 1, 2) + '-14');
    }

    openRcs() {
        const allItems = Object.values(this.selectedRows).filter(d => !!d);
        if (!allItems.length) { this.toast('선택된 오더가 없습니다'); return; }

        const missing = allItems.filter(d => !String(d.worker_name || '').trim() || !String(d.worker_phone || '').trim());
        if (missing.length) {
            const nums = missing.map(d => d.num).join(', ');
            Util.swalert(['받는 사람 정보를 확인해 주세요', 'warning',
                '수주자 이름 또는 연락처가 없는 오더가 있습니다.\n해당 오더 (' + nums + ')를 선택에서 제외하거나 정보를 입력한 뒤 다시 시도해 주세요.']);
            return;
        }

        // 본사 카테고리가 섞이면 발송 불가
        const cats = {};
        allItems.forEach(d => { cats[this.bonsaCategory(d.bonsa_name)] = true; });
        if (Object.keys(cats).length > 1) {
            Util.swalert(['다른 본사끼리는 LMS 발송이 불가합니다.', 'warning', '장비불러 / 삼성 / 그 외 본사는 분리해서 발송해 주세요.']);
            return;
        }

        const incomplete = allItems.filter(d => parseInt(d.order_status) !== 8);
        if (incomplete.length) {
            Util.swalert(
                ['미완료 작업이 포함되어 있습니다', 'warning',
                    '작업이 완료되지 않은 오더가 ' + incomplete.length + '건 포함되어 있습니다.\n 그래도 LMS를 발송하시겠습니까?'],
                () => this.openSendModal(allItems),
                ['발송', '취소']
            );
            return;
        }
        this.openSendModal(allItems);
    }

    openSendModal(items) {
        // 수주자(이름+폰) 단위 그룹핑
        const groupMap = {};
        items.forEach(d => {
            const key = d.worker_name + '|' + d.worker_phone;
            if (!groupMap[key]) {
                groupMap[key] = {nm:d.worker_name, ph:d.worker_phone, cnt:0, am:0, orders:[], cl:d.bonsa_name, biz:d.biz_name || d.worker_name};
            }
            const g = groupMap[key];
            g.cnt++;
            g.am += parseInt(d.car_price) || 0;
            g.orders.push({o:d.num, ad:d.address, dt:d.work_time, du:d.workhour, am:parseInt(d.car_price)||0, on:d.order_name||''});
        });
        this.rcsList = Object.values(groupMap);

        let totAm = 0;
        items.forEach(d => totAm += parseInt(d.car_price) || 0);
        $('#mt_c').text(this.rcsList.length);
        $('#mt_a').text(totAm.toLocaleString());

        this.rcsSelIdx = 0;
        this.renderRcsList();
        this.updatePrevLinkBtn();

        // 템플릿 셀렉트 채우기
        const $dd = $('#tplChangeSel').empty();
        this.tpls.forEach(t => $dd.append('<option value="'+t.id+'">'+t.nm+'</option>'));

        const mainCl = this.rcsList[0] ? this.rcsList[0].cl : '';
        const tpl = this.pickTpl(mainCl);
        if (tpl) $dd.val(tpl.id);

        this.currentTplBd = tpl ? tpl.bd : '';
        $('#sendMsg').val(this.currentTplBd);
        this.upMsgHL();

        const isSam = tpl && tpl.code === 'samsung';
        this.setupPickersByTpl(this.currentTplBd);
        this.applyDates();

        $('#sendTplBadge').text(tpl ? tpl.nm + ' 템플릿' : '')
            .attr('class', 'badge ' + (isSam ? 'badge-info' : 'badge-warning'));
        $('#sendPhoneDisplay').text(tpl && tpl.fromPhone ? Util.phoneNumber(tpl.fromPhone) : '');
        $('#sendPhoneLabel').text(tpl ? tpl.nm + ' 발송번호' : '');

        $('#sendMultiNote').text('');

        this.upPrev();
        $('#rcsOv').addClass('show');
    }

    changeTpl() {
        const id = $('#tplChangeSel').val();
        const tpl = this.tpls.find(x => x.id === id);
        if (!tpl) return;
        this.currentTplBd = tpl.bd;
        $('#sendMsg').val(tpl.bd);
        const isSam = tpl.code === 'samsung';
        $('#sendTplBadge').text(tpl.nm + ' 템플릿').attr('class', 'badge ' + (isSam ? 'badge-info' : 'badge-warning'));
        $('#sendPhoneDisplay').text(Util.phoneNumber(tpl.fromPhone || ''));
        $('#sendPhoneLabel').text(tpl.nm + ' 발송번호');
        this.setupPickersByTpl(this.currentTplBd);
        this.applyDates();
        this.upMsgHL();
        this.upPrev();
    }

    goToTplEdit() { window.open('/adm/alim/sms-template', '_blank'); }

    resetSendMsg() {
        const id = $('#tplChangeSel').val();
        const tpl = this.tpls.find(x => x.id === id);
        this.currentTplBd = tpl ? tpl.bd : '';
        this.applyDates();
        this.toast('메시지가 초기화되었습니다');
        this.upPrev();
    }

    // 발송번호 선택 — 환원 문자발송과 동일한 모달 목록선택 방식 (사전 등록 번호 중에서만 선택)
    openSenderModal() {
        this.tempSender = ($('#sendPhoneDisplay').text() || '').trim();
        this.renderSenderList();
        $('#senderOv').addClass('show');
    }
    closeSenderModal() { $('#senderOv').removeClass('show'); }
    renderSenderList() {
        const cur = this.tempSender;
        const rows = (this.senderPhones || []).map((p, i) => {
            const num = Util.phoneNumber(p);
            const nm  = i === 0 ? '대표번호' : '발신번호 ' + (i + 1);
            const on  = num === cur;
            return '<div class="rl-row' + (on ? ' active' : '') + '" onclick="$j.p.pickSender('+i+')">'
                 + '<span class="rl-radio' + (on ? ' on' : '') + '"></span>'
                 + '<span class="rl-phone" style="min-width:auto;flex:1">'+num+'</span>'
                 + '<span style="font-size:12px">'+nm+'</span>'
                 + '</div>';
        }).join('');
        $('#senderList').html(rows || '<div style="padding:14px;color:var(--adm-c-6c757d, #6c757d)">등록된 발신번호가 없습니다.</div>');
        $('#senderApplyBtn').prop('disabled', !this.tempSender);
    }
    pickSender(i) { this.tempSender = Util.phoneNumber(this.senderPhones[i]); this.renderSenderList(); }
    applySender() {
        if (!this.tempSender) { Util.swalert(['발송번호를 선택하세요','warning']); return; }
        $('#sendPhoneDisplay').text(this.tempSender);
        $('#sendPhoneLabel').text('변경됨');
        this.closeSenderModal();
        this.toast('발송번호가 ' + this.tempSender + '로 변경되었습니다');
    }

    upMsgHL() {
        const v = $('#sendMsg').val() || '';
        let h = v.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        h = h.replace(/\{(수주자|발주자|상호|본사|오더번호|건수|금액|합계금액|작성일자|작성시작일|작성종료일|결제일|현장주소|작업일시|소요시간|단축URL|세금계산서목록url)\}/g, '<span class="vr">{$1}</span>');
        h = h.replace(/(작성일자[^\n]*?)([\d]{2,4}[-./][\d]{1,2}[-./][\d]{1,2}(?:\([일월화수목금토]\))?[^\n]*)/g, '$1<span class="dt-wr">$2</span>');
        h = h.replace(/(결제예정일[^\n]*?)([\d]{2,4}[-./][\d]{1,2}[-./][\d]{1,2}(?:\([일월화수목금토]\))?[^\n]*)/g, '$1<span class="dt-pay">$2</span>');
        $('#msgBack').html(h);
    }

    // currentTplBd 는 항상 원본 본문을 유지. 날짜 picker 변경 시 원본 → 치환 → textarea 재그림.
    applyDates() {
        if (!this.currentTplBd) return;
        const wd  = this.fmtD($('#sdFrom').val()) || '';
        const wdf = this.fmtD($('#sdFrom').val()) || '';
        const wdt = this.fmtD($('#sdTo').val())   || '';
        const pd  = this.fmtD($('#sdPay').val())  || '';
        const r = this.currentTplBd
            .replace(/\{작성일자\}/g, wd)
            .replace(/\{작성시작일\}/g, wdf)
            .replace(/\{작성종료일\}/g, wdt)
            .replace(/\{결제일\}/g, pd);
        $('#sendMsg').val(r);
        this.upMsgHL();
        if ($('#prevPanel').is(':visible')) this.upPrev();
    }

    renderRcsList() {
        const $rl = $('#rl').empty();
        if (!this.rcsList.length) return;
        const $scroll = $('<div class="rl-scroll"></div>');
        this.rcsList.forEach((r, i) => {
            const $row = $('<div class="rl-row"></div>')
                .toggleClass('active', i === this.rcsSelIdx)
                .data('idx', i)
                .append('<span class="rl-num">'+(i+1)+'</span>')
                .append('<span class="rl-name">'+Util.escapeHtml(r.nm)+'</span>')
                .append('<span class="rl-phone">'+Util.escapeHtml(r.ph)+'</span>')
                .append('<span class="rl-cnt">'+r.cnt+'건</span>')
                .append('<span class="rl-amt">'+r.am.toLocaleString()+'원</span>');
            $scroll.append($row);
        });
        $rl.append($scroll);
    }

    selRcsRow(i) {
        this.rcsSelIdx = i;
        $('#rl .rl-row').removeClass('active')
            .filter(function(){ return $(this).data('idx') === i; }).addClass('active');
        this.upPrev();
        this.updatePrevLinkBtn();
    }

    updatePrevLinkBtn() {
        const r = this.rcsList[this.rcsSelIdx];
        const has = !!(r && r.cnt >= 1);
        $('#prevLinkBtn')
            .data('disabled', !has)
            .css({opacity: has ? 1 : 0.45, cursor: has ? 'pointer' : 'not-allowed'})
            .attr('title', has
                ? '문자는 발송하지 않고 링크만 생성해 새 탭에서 열기'
                : '선택된 수신자가 없습니다');
    }

    closeRcs() { $('#rcsOv').removeClass('show'); this.closePrevM(); }
    // 패널은 hidden 속성으로 여닫는다 — 예전 인라인 display:none 과 같은 뜻 (인라인 style 은 남지 않는다)
    openPrevM() { this.upPrev(); $('#prevPanel').prop('hidden', false); $('#prevBtn').text('📱 미리보기 닫기'); }
    closePrevM() { $('#prevPanel').prop('hidden', true); $('#prevBtn').text('📱 미리보기'); }
    togPrevM() { $('#prevPanel').is(':visible') ? this.closePrevM() : this.openPrevM(); }

    // 미리보기용 가짜 토큰 — 서버 bin2hex(random_bytes(8)) 와 동일 형태(16자 hex)
    fakeToken() {
        const hex = '0123456789abcdef';
        let t = '';
        for (let i = 0; i < 16; i++) t += hex[Math.floor(Math.random() * 16)];
        return t;
    }

    fillTpl(bd, r, s, tc, ta) {
        const host = this.g5Host || window.location.origin;
        const fakeUrl = host + '/m/tax/' + this.fakeToken();
        let out = bd
            .replace(/\{수주자\}/g, r.nm)
            .replace(/\{발주자\}/g, s.on || '')
            .replace(/\{상호\}/g, r.biz || r.nm)
            .replace(/\{오더번호\}/g, s.o)
            .replace(/\{본사\}/g, r.cl || '')
            .replace(/\{현장주소\}/g, s.ad || '')
            .replace(/\{작업일시\}/g, s.dt || '')
            .replace(/\{소요시간\}/g, s.du || '')
            .replace(/\{금액\}/g, (s.am || 0).toLocaleString())
            .replace(/\{건수\}/g, tc + '건')
            .replace(/\{합계금액\}/g, ta.toLocaleString())
            .replace(/\{단축URL\}/g, fakeUrl)
            .replace(/\{세금계산서목록url\}/g, fakeUrl);
        out = out
            .replace(/\{작성일자\}/g, this.fmtD($('#sdFrom').val()))
            .replace(/\{작성시작일\}/g, this.fmtD($('#sdFrom').val()))
            .replace(/\{작성종료일\}/g, this.fmtD($('#sdTo').val()))
            .replace(/\{결제일\}/g, this.fmtD($('#sdPay').val()));
        return out;
    }

    upPrev() {
        const r = this.rcsList[this.rcsSelIdx];
        if (!r) return;
        const s = r.orders[0] || {};
        const bd = $('#sendMsg').val();
        const f = this.fillTpl(bd, r, s, r.cnt, r.am);
        const lbl = r.cnt > 1 ? '여러건' : '단건';
        const html = '<div class="mt3">오늘 오전 9:41</div>'
                   + '<div class="bw"><div class="bav">장</div>'
                   + '<div class="bc"><div class="bn">장비불러 <span class="vf2">✓</span></div>'
                   + '<div class="rb"><div class="rb-s"><span class="ico">⚡</span> 장비불러 '
                   + '<span style="font-size:9px;color:var(--adm-c-909090, #909090);margin-left:4px">LMS · ' + lbl + '</span>'
                   + '<span class="aw">▾</span></div>'
                   + '<div class="rb-b"></div></div>'
                   + '<div class="mrt">오전 9:41</div></div></div>';
        $('#ppb').html(html);
        $('#ppb .rb-b').text(f);
    }

    confirmSend() {
        const items = Object.values(this.selectedRows).filter(d => d && d.worker_name);
        const orderNums = items.map(d => d.num);
        if (!orderNums.length) { this.toast('선택된 오더가 없습니다'); return; }
        const message = ($('#sendMsg').val() || '').trim();
        if (!message) { this.toast('메시지를 입력하세요'); return; }

        const ph = $('#sendPhoneDisplay').text();
        const grpCnt = parseInt($('#mt_c').text()) || 0;
        const tplSel = this.tpls.find(x => x.id === $('#tplChangeSel').val());
        const detailPurpose = tplSel ? tplSel.code : '';

        Util.swalert(
            ['LMS 문자 발송', 'question',
                '발송번호 : ' + ph + '\n수신자 : ' + grpCnt + '명 · 오더 ' + orderNums.length + '건\n\n발송 후 취소할 수 없습니다. 계속하시겠습니까?'],
            () => {
                $.ajax({
                    url: '/adm/ajax/account/tax-message/send',
                    type: 'post',
                    data: { order_nums: orderNums, message, from_phone: ph, detail_purpose: detailPurpose },
                    success: (res) => {
                        if (res && res.ok) {
                            this.closeRcs();
                            this.toast('LMS 발송 요청 완료 (' + grpCnt + '명, ' + orderNums.length + '건)');
                            this.reloadAfterSend();
                        } else {
                            this.toast((res && res.message) || '발송 요청 실패');
                        }
                    },
                    error: () => this.toast('서버 오류가 발생했습니다'),
                });
            },
            ['발송', '취소']
        );
    }

    // 샘플 발송 — 작은 모달 열기 (송신 모달 위, 첫 수신자 번호 자동 채움·수정 가능)
    openSampleModal() {
        const r = this.rcsList && this.rcsList[0];
        if (!r || !r.orders || !r.orders.length) { this.toast('샘플 기준 수신자가 없습니다'); return; }
        if (!($('#sendMsg').val() || '').trim()) { this.toast('메시지를 입력하세요'); return; }
        $('#sampleSendPhone').val('');   // 빈칸으로 열기 (직접 입력)
        $('#sampleOv').addClass('show');
        setTimeout(() => $('#sampleSendPhone').trigger('focus'), 50);
    }

    closeSampleModal() {
        $('#sampleOv').removeClass('show');
    }

    // 확인 → 첫 수신자 내용으로 입력한 번호에만 1건 즉시 발송 (큐 적재)
    sampleSend() {
        const r = this.rcsList && this.rcsList[0];
        if (!r || !r.orders || !r.orders.length) { this.toast('샘플 기준 수신자가 없습니다'); return; }
        const orderNums = r.orders.map(o => o.o);
        const message = ($('#sendMsg').val() || '').trim();
        if (!message) { this.toast('메시지를 입력하세요'); return; }
        const ph = ($('#sampleSendPhone').val() || '').trim();
        if (!ph) { this.toast('수신번호를 입력하세요'); return; }
        const fromPh = $('#sendPhoneDisplay').text();
        const tplSel = this.tpls.find(x => x.id === $('#tplChangeSel').val());
        const detailPurpose = tplSel ? tplSel.code : '';

        $.ajax({
            url: '/adm/ajax/account/tax-message/sample-send',
            type: 'post',
            data: { order_nums: orderNums, message, from_phone: fromPh, phone: ph, detail_purpose: detailPurpose },
            success: (res) => {
                this.toast((res && res.message) || (res && res.ok ? '샘플 발송 요청 완료' : '샘플 발송 실패'));
                this.closeSampleModal();
            },
            error: () => this.toast('서버 오류가 발생했습니다'),
        });
    }

    previewLink() {
        if ($('#prevLinkBtn').data('disabled')) { this.toast('선택된 수신자가 없습니다'); return; }
        const r = this.rcsList[this.rcsSelIdx];
        if (!r || !r.orders || !r.orders.length) { this.toast('미리보기 대상 수신자가 없습니다'); return; }
        const orderNums = r.orders.map(o => o.o);
        const message = ($('#sendMsg').val() || '').trim();
        if (!message) { this.toast('메시지를 입력하세요'); return; }
        const ph = $('#sendPhoneDisplay').text();

        $.ajax({
            url: '/adm/ajax/account/tax-message/preview',
            type: 'post',
            data: {
                order_nums: orderNums, message, from_phone: ph,
                write_date: this.fmtD($('#sdFrom').val()),
                pay_date:   this.fmtD($('#sdPay').val()),
            },
            success: (res) => {
                if (res && res.ok && res.url) window.open(res.url, '_blank', 'noopener');
                else this.toast((res && res.message) || '미리보기 링크 생성 실패');
            },
            error: () => this.toast('서버 오류가 발생했습니다'),
        });
    }

    // ============================================================
    //  모달 글로벌 바인딩 (초기화 시 1회)
    //  네임스페이스 '.taxmsg' — destroy() 에서 일괄 off
    // ============================================================
    bindModalGlobalEvents() {
        $(document).on('keydown.taxmsg', (e) => {
            if (e.key === 'Escape') { this.closePrevM(); this.closeRcs(); }
        });
        // 바깥 클릭으로 닫기 — '누른 곳'도 배경일 때만. 창 안 textarea 에서 글자를 긁다가 창 밖에서 손을 떼면
        // 브라우저가 공통 조상인 오버레이에 click 을 쏴 창이 저절로 닫혔다(템플릿설정과 같은 구조, 2026-10-07 상필 님).
        let rcsOvDown = false;
        $('#rcsOv').on('mousedown.taxmsg', (e) => { rcsOvDown = (e.target === e.currentTarget); });
        $('#rcsOv').on('click.taxmsg', (e) => { if (rcsOvDown && e.target === e.currentTarget) this.closeRcs(); rcsOvDown = false; });
        $(document).on('click.taxmsg', '#rl .rl-row', (e) => this.selRcsRow($(e.currentTarget).data('idx')));

        // 화면의 버튼·칸 — data-tx="메서드" / data-tx-change="메서드" (예전 blade onclick·onchange)
        $(document).on('click.taxmsg', '[data-tx]', (e) => {
            const el = e.currentTarget, act = el.dataset.tx;
            if (act === 'showPage') this.showPage(el.dataset.pg, el);
            else if (typeof this[act] === 'function') this[act]();
        });
        $(document).on('change.taxmsg', '[data-tx-change]', (e) => this[e.currentTarget.dataset.txChange]());
        // 메시지 칸 — 하이라이트 겹층을 글자·스크롤에 맞춘다.
        // ⚠ 미리보기 갱신 조건은 예전 그대로다: 패널의 '인라인' display 가 block 일 때. 패널은 인라인 display 를 갖지
        //   않아 이 조건은 참이 되지 않는다 — 입력 중 미리보기가 따라가지 않는 것이 지금 동작이다(바꾸려면 따로)
        $(document).on('input.taxmsg', '#sendMsg', () => {
            this.upMsgHL();
            if (document.getElementById('prevPanel').style.display === 'block') this.upPrev();
        });
        // scroll 은 거품이 안 올라온다 — 칸에 직접 건다
        $('#sendMsg').on('scroll.taxmsg', function () { document.getElementById('msgBack').scrollTop = this.scrollTop; });
        $(document).on('keydown.taxmsg', '#sampleSendPhone', (e) => { if (e.key === 'Enter') this.sampleSend(); });
    }

    /**
     * $j.destroy('Pages.Admin.TaxMessage') 호출 시 정리.
     * 페이지 전환·HMR 시 document 에 잔존하는 핸들러 누수 방지.
     */
    destroy() {
        $(document).off('.taxmsg');
        $('#rcsOv').off('.taxmsg');
        $('#sendMsg').off('.taxmsg');
        if (this.$reqTable) { this.$reqTable.destroy(); this.$reqTable = null; }
        if (this.$logTable) { this.$logTable.destroy(); this.$logTable = null; }
    }
}